import React from 'react';
export const FooterSection = () => {
  return <footer className="bg-familia-bg border-t border-familia-section py-10 md:py-16 px-4 md:px-6" data-id="element-78" data-mp="21gp3ubuhzrky">
      <div className="max-w-7xl mx-auto w-[92%] md:w-full" data-id="element-79" data-mp="338q046lf6gcg">
        <div className="flex flex-col items-center text-center mb-8 md:mb-12" data-id="element-80" data-mp="3h7prvn48bbcu">
          <div className="flex flex-col mb-4" data-id="element-81" data-mp="3c965jllq3xjy">
            <span className="text-familia-cyan font-display text-2xl sm:text-3xl font-bold leading-tight" data-id="element-82" data-mp="3cah7rgzisx8y">
              📚 VITALITY 360™
            </span>
            <span className="text-familia-gray text-xs sm:text-sm font-semibold tracking-widest uppercase mt-1" data-id="element-83" data-mp="2kj1ljo1vlcj9">
              Complete Printable Care Kit
            </span>
          </div>
          <div className="flex flex-wrap justify-center gap-x-8 gap-y-4 text-sm text-familia-gray mt-8" data-id="element-84" data-mp="2tjg80qqksxoc">
            <a href="mailto:support@vitality360.com" className="hover:text-familia-cyan transition-colors" data-id="element-85" data-mp="25t3satp39wn7">
              📧 support@vitality360.com
            </a>
            <a href="#" className="hover:text-familia-cyan transition-colors" data-id="element-86" data-mp="1ghhux7umrqpm">
              📲 @vitality360
            </a>
            <a href="#" className="hover:text-familia-cyan transition-colors" data-id="element-87" data-mp="1lehy9b03ifd1">
              🌐 www.vitality360.com
            </a>
          </div>
        </div>
        <div className="w-full h-px bg-familia-cyan/15 mb-12" data-id="element-88" data-mp="1v648b40p68e7" />
        <div className="max-w-4xl mx-auto space-y-6 text-center text-[10px] sm:text-xs text-familia-gray leading-relaxed" data-id="element-89" data-mp="1v7p1ap7d5j9y">
          <p data-id="element-90" data-mp="12goxae918fia">
            © VITALITY 360™ 2026 — All rights reserved. Reproduction without
            express authorization is prohibited.
          </p>
          <p data-id="element-91" data-mp="17egpzahi45nj">
            Vitality 360™ is an educational wellness and activity resource. It
            is not medical advice and is not intended to diagnose, treat, cure
            or prevent any medical condition. Always follow the recommendations
            of your loved one's healthcare professional.
          </p>
        </div>
      </div>
    </footer>;
};